<style lang="scss" scoped>
.uc-profile {
    border: 1px solid #4b8df8;
    margin-bottom: 15px;
    &-title {
        line-height: 40px;
        background-color: #4b8df8;
        color: #fff;
        padding: 0 15px;
    }
    &-content {
        .uc-item {
            border-bottom: 1px solid #ccc;
            padding: 5px 10px;
            margin: 0;
            font-size: 12px;
        }
    }
}

.font-weight-phone {
    // font-size: 16px;
    font-weight: bold;
}

.button-container {
    text-align: center;
}

.mfa-validator-tip {
    padding: 15px 20px;
    h3 {
        margin: 15px 0;
    }
    p {
        margin: 5px 0;
        font-weight: bold;
    }
    .download-step {
        margin: 10px 0 10px 15px;
    }
}
.qr-code-content {
    padding: 15px 20px;
    width: 60%;
    margin: 0 auto;
    text-align: center;
}
.mfa-modal-tip {
    font-size: 12px;
    font-weight: bold;
    margin: 15px 0;
}
.mfa-modal-button {
    text-align: center;
}
.mfa-secret-modal {
    p {
        margin: 15px 0;
        font-size: 12px;
        font-weight: bold;
    }
    .secret {
        text-align: center;
    }
}
.change-password {
    margin-left: 30px;
}
</style>


<template>
    <div>
        <Bread v-bind="bread" />
        <div class="uc-profile">
            <h3 class="uc-profile-title">
                <Icon type="ios-person" size="16"></Icon>账户基本信息
            </h3>
            <Form class="uc-profile-content" ref="form" :label-width="200">
                <FormItem label="用户昵称" class="uc-item">
                    <Input v-model="username" v-if="edit" />
                    <span v-else style="line-height: 34px">{{ username }}</span>
                    <a class="change-password" href="/home/password">修改密码</a>
                </FormItem>
            </Form>
        </div>
        <compWrapper theme="primary" title="登录邮箱">
            <Col offset="8" span="12">
                <Form
                    class="clearfix margin-top-15"
                    :labelWidth="100"
                    :model="userInfo"
                >
                    <!-- 未绑定 -->
                    <div v-if="emailStatus === 0">
                        <FormItem label="邮箱" prop="email">
                            <Col span="10">
                                <div class="font-weight-phone">未绑定</div>
                            </Col>
                            <Button
                                class="margin-left-15"
                                type="primary"
                                @click="bindEmail"
                                >绑定邮箱</Button
                            >
                        </FormItem>
                    </div>
                    <!-- 已绑定 -->
                    <div v-else>
                        <FormItem label="邮箱" prop="email">
                            <Col span="10">
                                <div class="font-weight-phone">
                                    {{ userInfo.email }}（已绑定）
                                </div>
                            </Col>
                            <Button type="warning" @click="unbindEmail"
                                >解除绑定</Button
                            >
                        </FormItem>
                    </div>
                </Form>
            </Col>
        </compWrapper>
        <compWrapper theme="primary" title="登录手机号">
            <Col offset="8" span="10">
                <Form
                    class="clearfix margin-top-15"
                    :labelWidth="100"
                    :model="userInfo"
                >
                    <!-- 未绑定 -->
                    <div v-if="phoneStatus === 0">
                        <FormItem label="手机号">
                            <Button
                                class="margin-left-15"
                                type="primary"
                                @click="bindPhone"
                                >绑定手机</Button
                            >
                        </FormItem>
                    </div>
                    <!-- 已绑定 -->
                    <div v-else>
                        <FormItem label="手机号">
                            <Col span="12">
                                <div class="font-weight-phone">
                                    {{ userInfo.phone }}（已绑定）
                                </div>
                            </Col>
                            <Button
                                class="margin-right-15"
                                type="primary"
                                @click="changePhone"
                                >修改手机号</Button
                            >
                            <Button type="warning" @click="unbindPhone"
                                >解除绑定</Button
                            >
                        </FormItem>
                    </div>
                </Form>
            </Col>
        </compWrapper>
        <compWrapper theme="primary" title="两步验证">
            <Col offset="8" span="8">
                <Form
                    class="clearfix margin-top-15"
                    :labelWidth="100"
                    :model="MFAData"
                >
                    <FormItem
                        label="两步验证方式"
                        prop="mfaType"
                        :rules="required"
                    >
                        <Select
                            v-model="MFAData.mfaType"
                            @on-change="handleType"
                        >
                            <Option
                                v-for="item in mfaTypeList"
                                :key="item.key"
                                :value="item.value"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                </Form>
            </Col>
        </compWrapper>
        <compWrapper
            v-if="MFASecretStatus === 1"
            theme="warning"
            title="MFA验证器"
        >
            <div class="mfa-validator-tip">
                <h3>下载认证器应用程序</h3>
                <p>
                    您可以使用认证器应用程序生成随机代码以登录帐户。
                    它们无法获取 您的密码或帐户信息。
                    您可自行选择想要使用的任何应用程序。
                </p>
                <p>如何下载：</p>
                <p class="download-step">1. 前往手机的应用商店。</p>
                <p class="download-step">2. 搜索“认证器应用程序”。</p>
                <p class="download-step">
                    3. 下载应用程序。（例如： AWS Virtual MFA、Google
                    身份验证器、<a
                        href="https://www.microsoft.com/zh-CN/account/authenticator"
                        target="blank"
                        >Microsoft Authenticator）</a
                    >
                </p>
                <h3>认证器应用程序</h3>
                <p>
                    用应用程序生成一次性密码。
                    无需连接网络。不会在每次登录时都以短信形式发送一次性密码给您，而是让您使用手机上的认证器应用程序生成一次性密码。
                    您将在登录时输入所产生的一次性密码，方式与使用短信接收一次性密码相同。
                </p>
                <p class="download-step">1. 打开您的认证器应用程序。</p>
                <p class="download-step">
                    2. 在应用程序中添加帐户，然后扫描下面的二维码。
                </p>
                <p class="download-step">
                    3. 输入一次性密码。
                    扫描二维码后，输入应用程序生成的一次性密码。
                </p>
            </div>

            <div
                v-if="!showQRCode"
                style="text-align: center; margin-bottom: 15px"
            >
                <Button type="primary" @click="validShowSecret"
                    >展示密钥信息</Button
                >
            </div>
            <div v-else class="qr-code-content">
                <img style="width: 250px" :src="MFAData.imgUrl" />

                <p style="padding: 15px 0; font-weight: bold">
                    <a @click="showSecret = true">无法扫描二维码？</a>
                </p>
                <div style="text-align: center">
                    <Button
                        v-if="secretBindType === 0"
                        class="margin-right-15"
                        type="primary"
                        @click="bindMFASecret"
                        >绑定</Button
                    >
                    <Button type="warning" @click="changeNewSercret"
                        >重新生成</Button
                    >
                </div>
            </div>
        </compWrapper>
        <Modal v-model="showSecret" title="MFA密钥" footer-hide>
            <div class="mfa-secret-modal">
                <p>1. 打开您的认证器应用程序并从菜单中选择“手动添加帐户”。</p>
                <p>2. 在“输入帐户名”中输入完整的电子邮箱。</p>
                <p>3. 在“输入密钥”中输入以下密钥（不需要空格）：</p>
                <p class="secret">{{ MFAData.mfaSecret }}</p>
                <p>4. 将密钥类型设置为“基于时间”。</p>
                <p>5. 点按添加。</p>
            </div>
        </Modal>
        <Modal
            v-model="modalProps.show"
            v-bind="modalProps"
            footer-hide
            :mask-closable="false"
        >
            <Form
                class="margin-15"
                ref="validForm"
                :model="validForm"
                :labelWidth="100"
                :rules="validFormRules"
            >
                <!-- 绑定邮箱 -->
                <div v-if="modalProps.modalType == 1">
                    <FormItem label="请输入邮箱" prop="email">
                        <Input v-model="validForm.email" type="text"></Input>
                    </FormItem>
                    <Button
                        class="margin-right-15"
                        type="success"
                        :disabled="sendEmailDisable"
                        @click="sendValidEmail"
                    >
                        发送验证邮件
                        <span v-if="sendEmailDisable"
                            >({{ sendEmailNowCount }})</span
                        >
                    </Button>
                    <Button type="default" @click="cancelModal">取消</Button>
                    <span class="margin-left-15 color-error">{{
                        modalProps.tip
                    }}</span>
                </div>
                <!-- 解绑邮箱|手机 -->
                <div
                    v-else-if="
                        modalProps.modalType == 2 || modalProps.modalType == 4
                    "
                >
                    <FormItem label="请输入密码" prop="password">
                        <Input
                            v-model="validForm.password"
                            type="password"
                        ></Input>
                    </FormItem>
                    <div class="button-container">
                        <Button
                            v-if="modalProps.modalType == 2"
                            class="margin-right-15"
                            type="primary"
                            @click="confirmUnbindEmail"
                            >确定</Button
                        >
                        <Button
                            v-else
                            class="margin-right-15"
                            type="primary"
                            @click="confirmUnbindPhone"
                            >确定</Button
                        >
                        <Button type="default" @click="cancelModal"
                            >取消</Button
                        >
                    </div>
                </div>
                <!-- 绑定手机 & 修改手机号 -->
                <div class="clearfix" v-else-if="modalProps.modalType == 3">
                    <FormItem class="clearfix" label="手机号" prop="phone">
                        <Row>
                            <Col class="clearfix" span="16">
                                <Input
                                    v-model="validForm.phone"
                                    clearable
                                ></Input>
                            </Col>
                            <Col class="clearfix" span="8">
                                <Button
                                    class="margin-left-25"
                                    type="warning"
                                    :disabled="sendDisable"
                                    @click="sendValidCode"
                                    >发送验证码
                                    <span v-if="sendDisable"
                                        >({{ sendNowCount }})</span
                                    ></Button
                                >
                            </Col>
                        </Row>
                    </FormItem>
                    <FormItem label="验证码" prop="validCode">
                        <Input v-model="validForm.validCode" clearable></Input>
                    </FormItem>
                    <div class="button-container">
                        <Button
                            class="margin-right-15"
                            type="primary"
                            @click="confirmBindPhone"
                            >确定</Button
                        >
                        <Button type="default" @click="cancelModal"
                            >取消</Button
                        >
                    </div>
                </div>
            </Form>
        </Modal>
        <Modal
            v-model="mfaModal.show"
            v-bind="mfaModal"
            footer-hide
            :mask-closable="false"
            @on-cancel="cancelMfaType"
        >
            <div class="mfa-modal-tip">{{ mfaModal.tip }}</div>
            <Form
                :model="mfaForm"
                ref="mfaForm"
                :rules="validFormRules"
                :labelWidth="100"
            >
                <FormItem
                    v-if="mfaModal.mfaModalType === 1"
                    prop="password"
                    label="请输入密码"
                >
                    <Input v-model="mfaForm.password" type="password"></Input>
                </FormItem>
                <FormItem v-else prop="validCode" label="请输入验证码">
                    <Input v-model="mfaForm.validCode"></Input>
                </FormItem>
            </Form>
            <div class="mfa-modal-button">
                <Button type="primary" @click="mfaModal.confirm">提交</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import Bread from "@/components/bread";
import { mapState } from "vuex";
import {
    HttpUpdateUserInfo,
    HttpChannelBind,
    HttpBind,
    HttpSendMFACode,
    HttpSetMFA,
    HttpGetMFASecret,
    HttpResetMFASecret,
    HttpUnbind,
} from "@/service/port";
import { HttpUserInfo } from "@mods/service/base";
export default {
    components: {
        Bread,
    },
    data() {
        return {
            showSecret: false,
            userInfo: {},
            mfaType: 0,
            oldMfaType: 0,
            validForm: {},
            // 0 未绑定 1 已绑定
            emailStatus: 0,
            // 0 未绑定 1 已绑定
            phoneStatus: 0,
            username: "",
            edit: false,
            // 0 未绑定 1 已绑定
            secretBindType: 0,
            showQRCode: true,
            // 是否只查看密钥
            secretQuery: false,
            MFAData: {
                mfaType: 0,
                password: "",
                imgUrl: "",
                mfaSecret: "",
            },
            sendDisable: false,
            sendNowCount: 0,
            sendTimeCount: 30,
            sendTimer: null,
            sendEmailNowCount: 0,
            sendEmailTimer: null,
            sendEmailDisable: false,
            required: [
                {
                    required: true,
                    message: "请填写必填项",
                },
            ],
            modalProps: {
                show: false,
            },
            mfaModal: {
                show: false,
            },
            mfaForm: {},
            MFAModalData: {},
        };
    },
    watch: {
        sendNowCount: {
            handler(val) {
                if (val === 0) {
                    this.sendDisable = false;
                } else this.sendDisable = true;
            },
        },
        sendEmailNowCount: {
            handler(val) {
                if (val === 0) {
                    this.sendEmailDisable = false;
                } else this.sendEmailDisable = true;
            },
        },
    },
    mounted() {
        this.update();
    },
    computed: {
        validFormRules() {
            return {
                email: [
                    {
                        required: true,
                        message: "邮箱不能为空",
                    },
                ],
                password: [
                    {
                        required: true,
                        message: "密码不能为空",
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: "手机号不能为空",
                    },
                    {
                        trigger: "blur",
                        validator: (rule, value = "", callback) => {
                            if (
                                /^1(?:70\d|(?:9[89]|8[0-24-9]|7[135-8]|66|5[0-35-9])\d|3(?:4[0-8]|[0-35-9]\d))\d{7}$/.test(
                                    value
                                )
                            ) {
                                callback();
                            } else {
                                callback(
                                    new Error(
                                        this.$t("global.common.phone", {
                                            defaultValue: "请输入手机格式",
                                        })
                                    )
                                );
                            }
                        },
                    },
                ],
                validCode: [
                    {
                        required: true,
                        message: "验证码不能为空",
                    },
                    {
                        trigger: "blur",
                        validator: (rule, value = "", callback) => {
                            if (/[0-9]{6}/g.test(value)) {
                                callback();
                            } else {
                                callback(new Error("请输入6位数字"));
                            }
                        },
                    },
                ],
            };
        },
        mfaTypeList() {
            return [
                {
                    value: 0,
                    label: "关闭",
                },
                {
                    value: 1,
                    label: "验证器",
                },
                {
                    value: 2,
                    label: "短信",
                },
            ];
        },
        bread() {
            let data = {};
            switch (this.lang) {
                case "en":
                    data = {
                        title: "Account Sercurity",
                        home: "Main Panel ",
                    };
                    break;
                default:
                    data = {
                        title: "账户安全",
                        home: "主面板 ",
                    };
                    break;
            }
            return data;
        },
    },
    methods: {
        // 获取信息
        async update() {
            await this.getUserInfo();
            this.username = this.userInfo.name;
            console.log(this.userInfo);
            // 是否已绑定手机
            if (this.userInfo.verifiedPhone === 1) {
                this.phoneStatus = 1;
            }
            // 未绑定
            else {
                this.phoneStatus = 0;
            }
            // 是否已绑定邮箱
            if (this.userInfo.verifiedEmail === 1) {
                this.emailStatus = 1;
            } else {
                this.emailStatus = 0;
            }
            // MFA设置
            this.$nextTick(() => {
                this.MFAData.mfaType = this.userInfo.mfaType;
                this.mfaType = this.userInfo.mfaType;
                this.oldmfaType = this.userInfo.mfaType;
                // 短信验证
                if (this.userInfo.mfaType === 2) {
                    this.oldMfaType = 2
                }
                // 验证器
                else if (this.userInfo.mfaType === 1) {
                    this.secretBindType = 1;
                    this.MFASecretStatus = 1;
                    this.showQRCode = false
                    this.oldMfaType = 1
                }
            });
        },
        // 隐藏modal
        cancelModal() {
            this.modalProps.show = false;
            this.$refs.validForm.resetFields();
        },
        // 隐藏mfaModal
        cancelMFAModal() {
            this.mfaModal.show = false;
            this.$refs.mfaForm.resetFields();
        },
        // 回滚mfa选项
        cancelMfaType() {
            console.log(this.oldMfaType)
            this.MFAData.mfaType = this.oldMfaType;
            this.mfaType = this.oldMfaType;
        },
        // 绑定手机号
        bindPhone() {
            this.modalProps = {
                show: true,
                title: "绑定手机",
                modalType: 3,
            };
        },
        // 修改手机号
        changePhone() {
            this.modalProps = {
                show: true,
                title: "修改手机号",
                modalType: 3,
            };
        },
        // 发送绑定|修改手机号验证码
        sendValidCode() {
            let flag = true;
            this.$refs.validForm.validateField("phone", (validText) => {
                if (validText) flag = false;
            });
            if (!flag) return;
            HttpChannelBind({
                via: 2,
                idlabel: this.validForm.phone,
            }).then(
                (res) => {
                    this.sendNowCount = this.sendTimeCount;
                    this.sendTimer = setInterval(() => {
                        if (this.sendNowCount === 0) {
                            return clearInterval(this.sendTimer);
                        }
                        this.sendNowCount--;
                    }, 1000);
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        // 确定绑定|修改手机号
        confirmBindPhone() {
            let flag = true;
            this.$refs.validForm.validate((valid) => {
                flag = valid;
            });
            if (!flag) return;
            HttpBind({
                via: 2,
                idlabel: this.validForm.phone,
                verify_token: this.validForm.validCode,
            }).then((res) => {
                this.$VMessage.success(res.message);
                this.cancelModal();
                this.update();
            });
        },
        // 解绑手机
        unbindPhone() {
            this.modalProps = {
                show: true,
                title: "解绑手机",
                modalType: 4,
            };
        },
        // 确定解绑手机
        confirmUnbindPhone() {
            let success = () => {
                this.phoneBindType = 0;
            };
            let flag = true;
            this.$refs.validForm.validate((valid) => {
                flag = valid;
            });
            if (!flag) return;
            // 解除绑定
            HttpUnbind({
                via: 2,
                password: this.validForm.password,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.cancelModal();
                    this.update();
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        // 绑定邮箱
        bindEmail() {
            this.modalProps = {
                show: true,
                title: "绑定邮箱",
                // 1 绑定邮箱 2 解绑邮箱 3 绑定手机 4 解绑手机
                modalType: 1,
            };
        },
        // 发送验证邮件
        async sendValidEmail() {
            let flag = true;
            await this.$refs.validForm.validate((valid) => {
                flag = valid;
            });
            if (!flag) return;
            HttpChannelBind({
                via: 3,
                idlabel: this.validForm.email,
            }).then(
                (res) => {
                    this.$set(
                        this.modalProps,
                        "tip",
                        "请在邮箱中点击链接以继续"
                    );
                    this.sendEmailNowCount = this.sendTimeCount;
                    this.sendEmailTimer = setInterval(() => {
                        if (this.sendEmailNowCount === 0) {
                            return clearInterval(this.sendEmailTimer);
                        }
                        this.sendEmailNowCount--;
                    }, 1000);
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        // 解绑邮箱
        unbindEmail() {
            this.modalProps = {
                show: true,
                title: "解绑邮箱",
                showFooter: false,
                modalType: 2,
            };
        },
        // 确定解绑邮箱
        confirmUnbindEmail() {
            let flag = true;
            this.$refs.validForm.validate((valid) => {
                flag = valid;
            });
            if (!flag) return;
            HttpUnbind({
                via: 3,
                password: this.validForm.password,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.modalProps.show = false;
                    this.$refs.validForm.resetFields();
                    this.emailStatus = 0;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        // 两步验证接口请求
        httpSetMFA(requestData, success) {
            HttpSetMFA(requestData).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    success();
                    this.cancelMFAModal();
                },
                (err) => {
                    this.$VMessage.error(err.message);
                    this.mfaType = this.oldMfaType;
                    this.MFAData.mfaType = this.oldMfaType;
                    return;
                }
            );
        },
        // 两步验证更换方式
        handleType(val) {
            switch (val) {
                // 关闭
                case 0:
                    {
                        this.mfaModal = {
                            show: true,
                            title: "关闭MFA验证",
                            tip: "关闭MFA验证，需要验证您的身份",
                            mfaModalType: 1,
                            confirm: () => {
                                let flag = true;
                                this.$refs.mfaForm.validate((valid) => {
                                    flag = valid;
                                });
                                if (!flag) return;
                                this.httpSetMFA(
                                    {
                                        via: 1,
                                        idlabel: this.userInfo.email,
                                        mfaType: 0,
                                        // verify_token: this.MFAData.vCode,
                                        password: this.mfaForm.password,
                                    },
                                    () => {
                                        this.MFAData.mfaType = 0;
                                        this.mfaType = 0;
                                        this.oldMfaType = 0;
                                        this.MFASecretStatus = 0;
                                    }
                                );
                            },
                        };
                    }
                    break;
                // 验证器
                case 1:
                    {
                        this.MFAData.mfaType = 1;
                        this.mfaModal = {
                            show: true,
                            title: "开启验证器验证",
                            tip: "开启MFA验证，需要验证您的身份",
                            mfaModalType: 1,
                            confirm: () => {
                                let flag = true;
                                this.$refs.mfaForm.validate((valid) => {
                                    flag = valid;
                                });
                                if (!flag) return;
                                HttpGetMFASecret({
                                    password: this.mfaForm.password,
                                }).then(
                                    (res) => {
                                        this.MFASecretStatus = 1;
                                        this.MFAData.imgUrl = res.data.data_uri;
                                        this.MFAData.mfaSecret =
                                            res.data.mfa_secret;
                                        this.cancelMFAModal();
                                        this.oldMfaType = 1;
                                        this.mfaType = 1;
                                    },
                                    (err) => {
                                        this.$VMessage.error(err.message);
                                    }
                                );
                            },
                        };
                    }
                    break;
                // 短信
                case 2:
                    {
                        // 没有绑定手机
                        if (this.userInfo.verifiedPhone !== 1) {
                            this.$VMessage.error("短信验证方式需要先绑定手机");
                            return (this.MFAData.mfaType = 0);
                        } else {
                            this.mfaModal = {
                                show: true,
                                title: "开启短信验证",
                                tip: "开启MFA验证，需要验证您的身份",
                                mfaModalType: 1,
                                // 点击提交，开启短信验证
                                confirm: () => {
                                    let flag = true;
                                    this.$refs.mfaForm.validate((valid) => {
                                        flag = valid;
                                    });
                                    if (!flag) return;
                                    this.httpSetMFA(
                                        {
                                            via: 2,
                                            idlabel: this.userInfo.phone,
                                            mfaType: 2,
                                            password: this.mfaForm.password,
                                        },
                                        () => {
                                            this.MFAData.mfaType = 2;
                                            this.mfaType = 2;
                                            this.oldMfaType = 2;
                                            this.MFASecretStatus = 0;
                                        }
                                    );
                                },
                            };
                        }
                    }
                    break;
            }
        },
        validShowSecret() {
            this.mfaModal = {
                show: true,
                title: "显示密钥",
                tip: "显示密钥需要验证您的身份",
                mfaModalType: 1,
                confirm: () => {
                    let flag = true;
                    this.$refs.mfaForm.validate((valid) => {
                        flag = valid;
                    });
                    if (!flag) return;
                    HttpGetMFASecret({
                        password: this.mfaForm.password,
                    }).then(
                        (res) => {
                            this.MFASecretStatus = 1;
                            this.MFAData.imgUrl = res.data.data_uri;
                            this.MFAData.mfaSecret = res.data.mfa_secret;
                            this.showQRCode = true
                            this.cancelMFAModal();
                        },
                        (err) => {
                            this.$VMessage.error(err.message);
                        }
                    );
                },
            };
        },
        // 重新生成MFA密钥
        changeNewSercret () {
            this.mfaModal = {
                show: true,
                title: "重新生成",
                tip: "重新生成密钥需要验证您的身份",
                mfaModalType: 1,
                confirm: () => {
                    let flag = true;
                    this.$refs.mfaForm.validate((valid) => {
                        flag = valid;
                    });
                    if (!flag) return;
                    HttpResetMFASecret({
                        password: this.mfaForm.password,
                    }).then(
                        (res) => {
                            this.MFASecretStatus = 1;
                            this.MFAData.imgUrl = res.data.data_uri;
                            this.MFAData.mfaSecret = res.data.mfa_secret;
                            this.showQRCode = true
                            this.cancelMFAModal();
                        },
                        (err) => {
                            this.$VMessage.error(err.message);
                        }
                    );
                },
            };
        },
        // 绑定mfa密钥
        bindMFASecret() {
            this.mfaModal = {
                show: true,
                title: "绑定密钥",
                tip: "请输入验证器中的随机验证码",
                mfaModalType: 2,
                confirm: () => {
                    let flag = true;
                    this.$refs.mfaForm.validate((valid) => {
                        flag = valid;
                    });
                    if (!flag) return;
                    HttpSetMFA({
                        via: 1,
                        idlabel: this.userInfo.email,
                        mfaType: this.MFAData.mfaType,
                        verify_token: this.mfaForm.validCode,
                    }).then(
                        (res) => {
                            this.$VMessage.success(res.message);
                            this.secretBindType = 1;
                            // this.hasMFA = true;
                            this.cancelMFAModal();
                        },
                        (err) => {
                            this.$VMessage.error(err.message);
                        }
                    );
                },
            };
        },
        async getUserInfo() {
            await HttpUserInfo().then((res) => {
                this.$store.commit("setUserInfo", res.data);
                this.userInfo = res.data;
            });
        },
    },
};
</script>